import React, { useEffect } from 'react';
import './styles/App.css';
import { Routes, Route } from "react-router-dom";
import Home from './Pages/Home';
import Error from './Error';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useAccount } from "@azure/msal-react";
import { SignInButton } from "./Components/Simple/SignInButton";
import { SignOutButton } from "./Components/Simple/SignOutButton";
import axios from 'axios';
import { getApiRequestByUrl } from './authConfig';
import Title from './Components/Simple/Title';
import { enableDashboard } from './Utils/features';

const authEnabled = process.env.REACT_APP_ENABLE_AUTH === "1";

function App() {
	const { instance, accounts, inProgress } = useMsal();
	const account = useAccount(accounts[0]);

	if (authEnabled) {
		useEffect(() => {
			const acquireToken = async (config) => {
				// we only want to fire off an additional request if one isn't already in progress
				
				if (!config.url.includes('blob.core.windows.net')) {
					try {
						if (!account) {
							throw Error('No active account! Verify a user has been signed in.');
						}
	
						const apiRequest = getApiRequestByUrl(config.url);
						const response = await instance.acquireTokenSilent({
							...apiRequest,
							account,
						});
	
						const bearer = `Bearer ${response.accessToken}`;
						config.headers.Authorization = bearer;
					} catch (e) {
						console.error(e);
					}
				}

				// we need to make sure we ALWAYS return the config....otherwise you will be pulled
				// down a rabbit hole of debugging the axios library looking for the cause of an
				// ambiguous error
				return config;
			};
			axios.interceptors.request.use(acquireToken);

			// make sure we are unregistering previously registered interceptors to prevent duplicates
			return () => {
				axios.interceptors.request.eject(acquireToken);
			};
		}, [instance, account, inProgress]);
	}

	const renderContent = () => {
		if (authEnabled) {
			return (
				<>
					<AuthenticatedTemplate>
						{renderPricer()}
					</AuthenticatedTemplate>

					<UnauthenticatedTemplate>
						<>
							<Title />
							<div className="row justify-content-center">
								<div className="col-auto text-center">
									<SignInButton />
								</div>
							</div>
						</>
					</UnauthenticatedTemplate>
				</>
			)
		}
		return renderPricer();
	};

	const renderPricer = () => {
		return (
			<Routes>
				{enableDashboard && <Route exact path="/" element={<Home />} />}
				<Route exact path="*" element={<Error />} />
			</Routes>)
	};

	return (
		<>
			<header>
				<div className="container logo-container">
					<div className="row justify-content-between align-items-center">
						<div className="col-auto">
							<img src="/images/Milliman logo_white.png" className="logo" />
						</div>
						<div className="col-auto">
							<div className="row align-items-center">
								{authEnabled && <AuthenticatedTemplate>
									<div className="col-auto">
										<SignOutButton className="rounded-pill" />
									</div>
								</AuthenticatedTemplate>}
							</div>
						</div>
					</div>
				</div>
			</header>

			<div className="container p-2 main">
				{renderContent()}
			</div>
		</>
	);
}

export default App;
